// extracted by mini-css-extract-plugin
export default {"accordionContainer":"LyFos9i4j1H5bRRPl1C9","accordionItem":"IkvSnDSbhO_EynBwgMWO","open":"erJDP1tkfYeoCrCWsCZP","accordionItemContent":"CHT7d10vOul4Z3bboTZN","itemArrow":"LxRuw5KwCtrSJHc8O6NC","accordionTitle":"p_j5NihZrs_Y6gl2mLP9"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"accordionContainer\":\"LyFos9i4j1H5bRRPl1C9\",\"accordionItem\":\"IkvSnDSbhO_EynBwgMWO\",\"open\":\"erJDP1tkfYeoCrCWsCZP\",\"accordionItemContent\":\"CHT7d10vOul4Z3bboTZN\",\"itemArrow\":\"LxRuw5KwCtrSJHc8O6NC\",\"accordionTitle\":\"p_j5NihZrs_Y6gl2mLP9\"}";
        // 1755964989525
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  